import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import "./index.sass";
import { Button, ButtonGroups } from "@nocios/presentation-kit";
import React from "react";

interface CustomProps {
  pageId: number;
  children: React.ReactNode;
  showNext?: boolean;
}

const Custom = ({ pageId, children }: CustomProps) => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const btn = { label: "Finish", type: "next", onClick: () => setCurrentPage(1) };

  return (
    <>
      {pageId === currentPage && (
        <div className="custom-center-content">
          <div className="custom-center-content-body">{children}</div>
          <ButtonGroups>{<Button {...btn} />}</ButtonGroups>
        </div>
      )}
    </>
  );
};

export default Custom;
